<template>
	<div class="work-section">
		<div class="work-section__top-sections-wrap">
			<div class="work-section__section work-section__section--mini">
				<h2 class="work-section__title">SCAN FOR INFO</h2>
				<div class="work-section__content">
					<ScanBox />
				</div>
			</div>

			<div class="work-section__section work-section__section--mini">
				<h2 class="work-section__title">CURRENT INFO</h2>
				<div class="work-section__content">
					<StatusBox />
				</div>
			</div>
		</div>

		<div class="work-section__section">
			<div class="work-section__title-wrap">
				<h2 class="work-section__title">Order Info / Other items in this order</h2>
			</div>
			<div class="work-section__content">
				<ProductTable />
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import ProductTable from "../components/info/ProductTable.vue";
import StatusBox from "../components/info/StatusBox.vue";
import ScanBox from "../components/info/ScanBox.vue";
//
export default Vue.extend({
	name: "Info",
	components: {
		ProductTable,
		StatusBox,
		ScanBox
	}
});
</script>

<style lang="scss" scoped>
.work-section {
	padding: 0 20px;

	&__top-sections-wrap {
		display: flex;
	}

	&__section {
		border: $border-color 1px solid;
		border-radius: 5px;
		margin-top: 50px;
		width: 100%;

		&--mini:first-child {
			margin-right: 10px;
			width: 35%;
		}

		&--mini:last-child {
			margin-left: 10px;
			width: 65%;
		}
	}

	&__title-wrap {
		position: relative;
	}

	&__title {
		border-bottom: $border-color 1px solid;
		background-color: $color7;
		text-align: center;
		font-weight: 600;
		line-height: 27px;
		font-size: 16px;
		padding: 5px 0;
	}

	&__btn {
		font-weight: 500;
		text-transform: uppercase;
		transform: translateY(-50%);
		border-radius: 5px;
		padding: 4px 15px;
		font-size: 12px;

		position: absolute;
		right: 20px;
		top: 50%;
	}

	&__content {
		padding: 20px 0;
	}
}
</style>